import { Component } from '@angular/core';
import { FieldConfig } from 'models/field.interface';
import { FormGroup } from '@angular/forms';
import { UtilityService } from 'services';

@Component({
  templateUrl: './textarea.component.html'
})
export class TextareaComponent {

  field: FieldConfig;
  group: FormGroup;
  constructor(private util: UtilityService) { }
  isRequired() {
    return this.util.isRequired(this.group.get(this.field.name));
  }
  getValidationMessage(val) {
    if (val === 'required') {
      return 'This field is required.';
    }
    return 'Invalid';
  }

}
